// extracted by mini-css-extract-plugin
export default {"modal":"CorrectDistance--modal--AqffP"};